import { faAngleRight } from "@jewlr/pro-regular-svg-icons/faAngleRight"
// import { faSparkles } from "@jewlr/pro-regular-svg-icons/faSparkles"
import PropTypes from "prop-types"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
// import { IS_US } from "helpers/application"
import useCountdown from "helpers/use-countdown"
import { cn } from "styles/utils"

import Markdown from "./markdown"
import Segment from "./segment"

const Clock = ({
  Comp,
  compProps,
  isSecondMicroBanner,
  text,
  triggerPopup,
}) => {
  let days = null
  let hours = null
  let minutes = null
  let seconds = null

  // if (sl.config.sale_key.includes("2023_holiday_sale")) {
  //   const targetDate = IS_NA()
  //     ? new Date() > Date.UTC(2023, 11, 13, 8)
  //       ? Date.UTC(2023, 11, 14, 8) // Thu 14th 3AM
  //       : Date.UTC(2023, 11, 13, 8) // Wed 13th 3AM
  //     : Date.UTC(2023, 11, 14, 10) // Thu 14th 5AM
  //   const counter = useCountdown(targetDate, true)
  //   days = counter[0]
  //   hours = counter[1]
  //   minutes = counter[2]
  //   seconds = counter[3]
  // }
  // const currentDate = Date.now()
  const nextDay = new Date().setHours(24, 0, 0, 0)
  // const targetDate =
  //   IS_US() &&
  //   currentDate >= Date.UTC(2024, 4, 10, 4) &&
  //   currentDate <= Date.UTC(2024, 4, 10, 19)
  //     ? Date.UTC(2024, 4, 10, 19) // Fri 9th 3PM
  //     : nextDay
  const counter = useCountdown(nextDay)
  hours = counter[0]
  minutes = counter[1]
  seconds = counter[2]

  return (
    <Comp data-lc="clock" {...compProps}>
      <div className="tablet:gap-12 flex items-center justify-center gap-16">
        {/* <StyledIcon icon={faSparkles} /> */}
        <div
          className={cn(
            "text-14 inline-block font-normal",
            isSecondMicroBanner ? "tablet:text-16" : "tablet:text-15",
            text.style?.className
          )}
        >
          {text.rich_text ? (
            <Markdown
              classNames={text.style?.classNames}
              defaultClassName="font-bold"
              triggerPopup={triggerPopup}
            >
              {text.rich_text}
            </Markdown>
          ) : (
            <span
              className="font-bold"
              dangerouslySetInnerHTML={{ __html: text.text }}
            />
          )}
          <FontAwesomeIcon
            className="text-12 mx-4 align-baseline"
            icon={faAngleRight}
          />
          <div className="inline-flex align-baseline">
            {days && (
              <>
                <Segment name="days" segment={days} />
                <span>d</span>
                <span className="mx-4" role="separator">
                  |
                </span>
              </>
            )}
            <Segment name="hours" segment={hours} />
            <span>h</span>
            <span className="mx-4" role="separator">
              |
            </span>
            <Segment name="minutes" segment={minutes} />
            <span>m</span>
            <span className="mx-4" role="separator">
              |
            </span>
            <Segment name="seconds" segment={seconds} />
            <span>s</span>
          </div>
        </div>
        {/* <StyledIcon flip="horizontal" icon={faSparkles} /> */}
      </div>
    </Comp>
  )
}

Clock.propTypes = {
  Comp: PropTypes.elementType,
  compProps: PropTypes.object,
  isSecondMicroBanner: PropTypes.bool,
  text: PropTypes.object,
  triggerPopup: PropTypes.func,
}

export default Clock
